import { ThemeEvents } from '@theme/events';

/**
 * Swaps the visible product description to match the selected variant.
 *
 * The default description is rendered server-side as `.aeon-description-default`.
 * Each variant that has a `custom.variant_description` metafield is rendered as
 * a hidden `.aeon-description-variant` sibling. On variant change, the matching
 * variant panel is shown and the default is hidden; if no variant override exists
 * for the selected variant, the default is shown.
 */
class ProductDescriptionComponent extends HTMLElement {
  connectedCallback() {
    this.updateDescription = this.updateDescription.bind(this);
    document.addEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this.updateDescription);
  }

  updateDescription(event) {
    const { resource, data } = event.detail ?? {};
    const productId = data?.productId;

    if (productId && this.dataset.productId && String(productId) !== this.dataset.productId) return;
    if (!resource) return;

    const variantId = String(resource.id);
    const variantPanels = this.querySelectorAll('.aeon-description-variant');
    const defaultPanel = this.querySelector('.aeon-description-default');
    let matched = false;

    variantPanels.forEach((panel) => {
      const isMatch = panel.dataset.variantId === variantId;
      panel.hidden = !isMatch;
      if (isMatch) matched = true;
    });

    if (defaultPanel) {
      defaultPanel.hidden = matched;
    }

    this.dataset.selectedVariantId = variantId;
  }
}

if (!customElements.get('product-description-component')) {
  customElements.define('product-description-component', ProductDescriptionComponent);
}
